import { ColorNordicGrey5, Spacing16, Spacing24, Spacing8 } from 'autogen/design-tokens/tokens';
import React, { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';

export type ButtonCTAGroupType = {
    size: 'sm' | 'lg';
    layout?: 'column' | 'row'; // if not specificed it will default to row
    background?: boolean;
};

const Wrapper = styled.div<ButtonCTAGroupType>`
    display: grid;
    gap: ${Spacing8};
    width: 100%;
    padding: ${Spacing16};
    grid-template-columns: ${({ layout }) => (layout === 'column' ? '1fr' : '1fr 1fr')};

    ${({ background }) =>
        background &&
        css`
            background-color: ${ColorNordicGrey5};
        `}

    ${({ size }) =>
        size === 'lg' &&
        css`
            ${breakpoint.up(sizes.sm)} {
                padding: ${Spacing24};
            }
        `}
`;

export default function ButtonCTAGroup(props: ButtonCTAGroupType & HTMLAttributes<HTMLDivElement>) {
    const { size, layout, background, children, ...restProps } = props;

    return (
        <Wrapper size={size} layout={layout} background={background} {...restProps}>
            {children}
        </Wrapper>
    );
}
